module.exports = __webpack_public_path__ + "static/media/bytt-no-19.cbd9d07f.mp3";